/*
Used to cancel previous fetch request if new request is made
For detailed description - https://developer.mozilla.org/en-US/docs/Web/API/AbortController
*/
class abortControllerClass {
    constructor(abortController) {
        this.abortController = abortController;
    }
}
export default abortControllerClass;
